'use client'

import React from 'react'
import classNames from 'classnames'
import { Header } from '@/ui/components/Header'
import RichText from '@/ui/components/RichText'
import { Quote, type QuoteProps } from '@/ui/atoms/Quote'
import { ValueProps } from '@/ui/components/ValueProps'
import { Button, ButtonContent } from '@/ui/atoms/Button'
import Link from 'next/link'
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical'

export type QuoteData = QuoteProps

export type ValuePropItem = {
  value: string
  label: string
  variant?:
    | 'neutral'
    | 'blue'
    | 'light-blue'
    | 'subtle-blue'
    | 'error'
    | 'success'
    | 'warning'
    | 'transparent'
    | 'transparentInverted'
    | 'orange'
    | 'plain'
}

export type ButtonData = {
  label: string
  href: string
  variant?:
    | 'primary'
    | 'secondary'
    | 'primaryInverted'
    | 'secondaryInverted'
    | 'ghost'
    | 'ghostInverted'
}

interface QuoteWithValuePropsProps {
  label?: string
  title?: string
  description?: string | SerializedEditorState
  quote: QuoteData
  valueProps: ValuePropItem[]
  buttons?: ButtonData[]
  className?: string
  /** Optional content rendered between Header and ValueProps (e.g. homepage search hero) */
  headerSlot?: React.ReactNode
}

export const QuoteWithValueProps: React.FC<QuoteWithValuePropsProps> = ({
  label,
  title,
  description,
  quote,
  valueProps,
  buttons,
  className,
  headerSlot,
}) => {
  return (
    <div className={classNames('w-full', className)}>
      {/* Header Section */}
      {(label || title || description) && (
        <div className="mb-10">
          <Header label={label} title={title} description={undefined} />

          {/* Optional injected slot (used by homepage to render search hero here) */}
          {headerSlot && <div className="mt-12 mb-12">{headerSlot}</div>}

          {/* Value Props Section */}
          {valueProps && valueProps.length > 0 && (
            <div className="my-20">
              <ValueProps items={valueProps} />
            </div>
          )}

          {/* Quote Section */}
          <Quote
            text={quote.text}
            authorName={quote.authorName}
            authorTitle={quote.authorTitle}
            authorImage={quote.authorImage}
            className="mb-10"
            hideQuoteMarks
          />

          {/* Buttons Section */}
          {/* {buttons && buttons.length > 0 && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {buttons.map((button, index) => (
                <Button key={index} asChild variant={button.variant || 'primary'} size="md">
                  <Link href={button.href}>
                    <ButtonContent label={button.label} />
                  </Link>
                </Button>
              ))}
            </div>
          )} */}
          {/* {description && (
            <>
              {typeof description === 'string' ? (
                <p className="text-body-M-regular text-text-subtle xl:w-2/3 mx-auto text-center mt-6">
                  {description}
                </p>
              ) : (
                <div className="xl:w-2/3 mx-auto text-center mt-6">
                  <RichText
                    data={description}
                    className="text-body-M-regular text-text-subtle prose-p:!text-body-M-regular prose-p:!text-text-subtle prose-p:!mb-0"
                    enableGutter={false}
                    enableProse={false}
                  />
                </div>
              )}
            </>
          )} */}
        </div>
      )}
    </div>
  )
}
